/**
 * 브랜드 공유 페이지(비회원)의 가입 안내 — 문서 끝에 선다(`PublicShareShell` `gate="end"`).
 */
export const BRAND_HUB_SHARE_PITCH = {
  title: '브랜드 하나를 소셜·광고·판매몰까지 한눈에',
  body: '이름 하나로 언급 추이·채널·광고·판매몰 상품과 많이 다룬 계정을 모아 봅니다.',
};
